import { Component, OnInit, inject } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { LoginService } from '../login/login.service';
import { ProfileService } from './profile.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [MatButtonModule, MatGridListModule],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.css'
})
export class ProfileComponent implements OnInit {

  loginService = inject(LoginService);
  profileService = inject(ProfileService);
  bottomSheetRef = inject(MatBottomSheetRef);
  perfil: any = null;

  ngOnInit(): void {
    firstValueFrom(this.profileService.getProfile()).then((item) => {
      this.perfil = item;
    });
  }

  cerrarSesion(event: MouseEvent): void {
    this.bottomSheetRef.dismiss();
    this.loginService.logout();
    event.preventDefault();
  }
}